import UltMeta, { Meta } from "./UltMeta/index";

/**
 *通知类型
 */
class NotificationType extends UltMeta {
    SYSTEM_NOTIFICATION = new Meta(1, "系统通知");
    OPERATIONAL_NOTIFICATION = new Meta(2, "运营通知");
}
export const NOTIFICATION_TYPE = new NotificationType();

/**
 *发布类型
 */
class PublishStatus extends UltMeta {
    DRAFT = new Meta(1, "草稿");
    PENDING = new Meta(2, "待发布");
    PUBLISHED = new Meta(3, "已发布");
}
export const PUBLISH_STATUS = new PublishStatus();

/**
 *发布类型
 */
class ReadState extends UltMeta {
    UNREAD = new Meta(1, "未读");
    READ = new Meta(2, "已读");
    DELETED = new Meta(3, "已删除");
}
export const READ_STATE = new ReadState();
